export default __webpack_public_path__ + "assets/images/c3600ded37b0cd346fcf7005100c7d5a.svg";